<div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div class="card-body">
      <div class="row align-items-center d-flex justify-content-between">
        <div class="col-12 col-md-5">
          <h2 class="custom-card-title">Partners</h2>
        </div>

        <div class="col-12 col-md-5 d-flex justify-content-end gap-2 flex-column flex-md-row">

          <div>
            <!-- Create New Partner Button -->
            <a routerLink="/partner-submission" class="btn btn-primary d-flex align-items-center"
               *ngIf="teacher?.role !== 'Science Directors'">
              New Partner
              <span class="material-symbols-outlined ms-1">add</span>
            </a>
          </div>
          <div>
            <button class="btn btn-primary d-flex align-items-center"
                    (click)="exportCSV(displayPartners,'Partners.csv')" id="download">
              <span *ngIf="!downloadedTable" class="material-symbols-outlined me-1"
                    style="font-size: 1.2rem">download</span>
              <span *ngIf="downloadedTable" class="material-symbols-outlined me-1"
                    style="font-size: 1.2rem"> download_done</span>
              Export Partners
            </button>
          </div>
        </div>
      </div>
      <div class="row align-items-center mb-3 d-flex justify-content-between">
        <div class="col-12 col-md-5 mb-3">
          <input type="text" class="form-control" placeholder="Search partners..." [(ngModel)]="searchText"
                 (input)="filterResults()">
        </div>

        <select *ngIf="teacher?.role === 'Admin'" class="form-select mb-3" (change)="showPartners($event)">
          <option disabled>Admin Filter</option>
          <option selected value="All Partners">All Partners</option>
          <option value="Deleted">Deleted</option>
          <option value="Active">Active</option>
        </select>

        <div class="col-12 col-md-5 d-flex justify-content-end gap-2 flex-column flex-md-row">
          <select class="form-select mb-3" aria-label="Number of cards per page" (change)="selectChange($event)">
            <option selected value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="All">All</option>
          </select>
          <div class="dropdown mb-3">
            <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside">
              {{ servicesDropdownText }}
            </button>
            <ul class="dropdown-menu">
              <li *ngFor="let service of findPartnersForm.possibleServices">
                <label class="dropdown-item user-select-none">
                  <input class="form-check-input" type="checkbox" [value]="service"
                         [checked]="findPartnersForm.servicesOffered.includes(service)"
                         (change)="onServiceChanged($event, service)">
                  {{ findPartnersForm.filterLabels[service] }}
                </label>
              </li>
            </ul>
          </div>

          <div class="dropdown mb-3">
            <button class="btn btn-primary dropdown-toggle w-100" type="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside">
              {{ focusAreasDropdownText }}
            </button>
            <ul class="dropdown-menu w-100">
              <li *ngFor="let area of findPartnersForm.possibleFocusAreas">
                <label class="dropdown-item user-select-none">
                  <input class="form-check-input" type="checkbox" [value]="area"
                         [checked]="findPartnersForm.focusAreas.includes(area)"
                         (change)="onFocusAreaChanged($event, area)">
                  {{ findPartnersForm.filterLabels[area] }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="row-section">
        <table class="table">
          <thead>
          <tr>
            <th>
              <select class="form-select form-select-sm" (change)="onStatusSortChange($event)">
                <option value="">Partner Status</option>
                <option *ngFor="let status of partnerStatusOrder" [value]="status">{{ status }}</option>
              </select>
            </th>
            <th (click)="sort('partnerName')">
              Partner Name
              <span *ngIf="getSortDir('partnerName') === 'asc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
              <span *ngIf="getSortDir('partnerName') === 'desc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
              <span *ngIf="getSortDir('partnerName') !== 'desc' && getSortDir('partnerName') !== 'asc'"
                    class="material-symbols-outlined">swap_vert</span>
            </th>
            <th (click)="sort('date')">
              Created Date
              <span *ngIf="getSortDir('date') === 'asc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
              <span *ngIf="getSortDir('date') === 'desc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
              <span *ngIf="getSortDir('date') !== 'desc' && getSortDir('date') !== 'asc'"
                    class="material-symbols-outlined">swap_vert</span>
            </th>
            <th (click)="sort('updatedDate')">
              Updated Date
              <span *ngIf="getSortDir('updatedDate') === 'asc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
              <span *ngIf="getSortDir('updatedDate') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
              <span *ngIf="getSortDir('updatedDate') !== 'desc' && getSortDir('updatedDate') !== 'asc'"
                    class="material-symbols-outlined">swap_vert</span>
            </th>
            <th (click)="sort('contactName')">
              Contact Name
              <span *ngIf="getSortDir('contactName') === 'asc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
              <span *ngIf="getSortDir('contactName') === 'desc'"
                    class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
              <span *ngIf="getSortDir('contactName') !== 'desc' && getSortDir('contactName') !== 'asc'"
                    class="material-symbols-outlined">swap_vert</span>
            </th>
          </tr>
          </thead>
          <tbody *ngIf="pagedCards.length > 0; else noPartners">
          <ng-container *ngFor="let partner of pagedCards; let i = index">
            <!-- Main Row -->
            <tr
              (click)="onPartnerCardClicked(partner.urlOrg)"
            >
              <td (mouseenter)="hoveredRow = i"
                  (mouseleave)="hoveredRow = null"
                  style="cursor:pointer;">
                {{ partner.status }}
              </td>
              <td>{{ partner.org }}</td>
              <td>{{ partner.createdAt?.toDate()?.toISOString()?.slice(0, 10) }}</td>
              <td>{{ partner.modifiedAt?.toDate()?.toISOString()?.slice(0, 10) }}</td>
              <td>{{ partner.primeContact }}</td>
            </tr>

            <!-- Hover -->
            <tr *ngIf="hoveredRow === i">
              <td colspan="6" class="p-0">
                <div class="p-3 m-0">
                  <app-partner-card
                    [partner]="partner"
                    (cardClicked)="onPartnerCardClicked($event)">
                  </app-partner-card>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
        <ul class="pagination" *ngIf="totalPages > 1">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="goToPrevious()">Previous</a>
          </li>

          <ng-container *ngFor="let page of pages">
            <li class="page-item" *ngIf="page === 1"
                [class.active]="page === currentPage">
              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item disabled"
                *ngIf="page === currentPage - 2 && page > 2">
              <span class="page-link">…</span>
            </li>
            <li class="page-item"
                *ngIf="page >= currentPage - 1 && page <= currentPage + 1 && page !== 1 && page !== totalPages"
                [class.active]="page === currentPage">
              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item disabled"
                *ngIf="page === currentPage + 2 && page < totalPages - 1">
              <span class="page-link">…</span>
            </li>
            <li class="page-item" *ngIf="page === totalPages"
                [class.active]="page === currentPage">
              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
            </li>
          </ng-container>

          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="goToNext()">Next</a>
          </li>
        </ul>
      </div>

      <ng-template #noPartners>
        <div class="col-12">
          <p class="mb-4">There are no partners.</p>
        </div>
      </ng-template>

    </div>
  </div>
</div>
